import { useQuery } from '@tanstack/react-query'
import { apiFetch } from './client'

// GET/PUT /admin/connectors/{connector_ref}/tool-selection (symone-v2
// gateway/api/promote.py; openapi.yaml ToolSelection / ToolSelectionRequest /
// ToolSelectionResult). OpenAPI-ingested connectors only: a built-in answers 400
// "Connector Not Supported". GET is platform-admin; PUT is platform-admin + CSRF.
export interface ToolSelectionTool {
  name: string
  is_active: boolean
}
export interface ToolSelection {
  connector_name: string
  curated: boolean
  tool_allowlist?: string[] | null
  active_tool_count: number
  tool_count: number
  tools: ToolSelectionTool[]
}
export interface ToolSelectionResult extends ToolSelection {
  activated: string[]
  deactivated: string[]
  changed: boolean
}

// The server's ToolSelectionRequest: `tools` has minItems 1 (null clears the
// curation, which this editor does not send).
export const MIN_SELECTED_TOOLS = 1

export const toolSelectionKey = (connectorName: string) =>
  ['admin-tool-selection', connectorName] as const

function toolSelectionPath(connectorName: string): string {
  return `/admin/connectors/${encodeURIComponent(connectorName)}/tool-selection`
}

export function useToolSelection(connectorName: string) {
  return useQuery<ToolSelection>({
    queryKey: toolSelectionKey(connectorName),
    queryFn: () => apiFetch<ToolSelection>(toolSelectionPath(connectorName)),
  })
}

export function putToolSelection(connectorName: string, tools: string[]) {
  return apiFetch<ToolSelectionResult>(toolSelectionPath(connectorName), {
    method: 'PUT',
    body: JSON.stringify({ tools }),
  })
}
